import { state } from './state.js';

/**
 * Controla la navegación en la SPA capturando cambios de estado en el histórico.
 * Se separa del router para evitar dependencias circulares con componentes de UI.
 */
export function navigateTo(path, push = true) {
    if (push) window.history.pushState({}, '', path);
    state.currentPath = path;
    
    // Disparar evento de ruteo
    const event = new CustomEvent('app-route', { detail: { path } });
    window.dispatchEvent(event);
    
    if (!path.startsWith('/carta/')) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
